import { ca } from '@cian/analytics';

import { EDeviceType } from '../../types/device';
import { EEntityType } from '../../types/filters';
import { IFavoriteEntity } from '../../types/results';
import { convertToFavoriteEntityType } from '../../utils/favoriteEntity';
import { getPageNumber, EOfferType } from '../../utils/trackings';

interface IPhonesEventParameters {
  entity: IFavoriteEntity;
  position: number;
  total: number;
  deviceType: EDeviceType;
}

export function trackPhoneButtonClick({ entity, position, total, deviceType }: IPhonesEventParameters) {
  ca('eventEbc', {
    category: 'Phones',
    action: 'Open_favorites',
    label: getCustomUrl(entity),
    name: 'oldevent',
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    },
    products: [favoriteEntityToTrackingProduct(entity, position)],
  });
}

export function trackCall({ entity, position, total, deviceType }: IPhonesEventParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Call_listing',
    label: getCustomUrl(entity),
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    },
    products: [favoriteEntityToTrackingProduct(entity, position)],
  });
}

export function favoriteEntityToTrackingProduct(entity: IFavoriteEntity, position: number) {
  /**
   * Объект products для карточки ЖК
   */
  if (entity.jkInfo) {
    return {
      id: entity.entityId,
      offerType: EOfferType.JK,
      position,
    };
  }

  /**
   * Объект products для карточки объявления
   */
  return {
    id: entity.entityId,
    offerType: EOfferType.Offer,
    position,
    published: entity ? entity.status === 'published' : false,
    extra: {
      isPartner: entity.isCianPartner || false,
    },
  };
}

export function getCustomUrl(favoriteEntity?: IFavoriteEntity): string | undefined {
  if (favoriteEntity) {
    const { dealType, entityType, entityId } = favoriteEntity;

    return `/${dealType}/${convertToFavoriteEntityType(entityType as unknown as EEntityType)}/${entityId}`;
  } else {
    return undefined;
  }
}
